const getCreatedAt = goal =>
	new Date(goal.createdAt || goal.created_at || goal.date || 0);

const getNewestGoal = goals =>
	goals.reduce((newest, goal) =>
		getCreatedAt(goal) > getCreatedAt(newest) ? goal : newest,
	);

export const pickOverviewGoal = goals => {
	if (goals.length === 0) return null;

	const goal = goals.find(g => g.is_default === true) ?? getNewestGoal(goals);
	return {
		savedAmount: Number(goal.current_amount ?? goal.savedAmount ?? 0) || 0,
		targetAmount: Number(goal.target_amount ?? goal.targetAmount) || 0,
		currency: goal.currency || 'USD',
	};
};
